import React from "react";

import {
    container,
    button,
    padlock,
    buttonContent,
    cardFooter,
    brandBox,
    desktopCard,
    desktopImageWrapper,
    desktopImage,
    desktopMeta,
    desktopCategory,
    desktopBrand,
    desktopActions,
    desktopZoom,
    desktopZoomIcon,
} from "./product-card.module.scss";
import useUser from "../../../apps/auth/hooks/use-user";
import { IProduct } from "../../../models/product.model";
import { postProductStatistic } from '../../../services/product-services';
import Padlock from "../../../components/molecules/padlock";
import ViewIcon from "../../../assets/images/svg/view.svg";

interface IProductCardProps {
    className?: string;
    classNameButtonContent?: string;
    onPadlockClick?: () => void;
    product: IProduct;
    productLength: number;
    isLocked?: boolean;
    nameProduct?: string;
    optionsProduct?: any[];
    labelProduct?: string;
    classNameProduct?: string;
    isTablet: boolean;
    showInputs?: boolean;
    readonly?: boolean;
    isMinimal?: boolean;
    productClickCustomFn?: (product: IProduct) => void;
}

const ProductCard: React.FC<IProductCardProps> = ({
    className = "",
    classNameProduct = "",
    classNameButtonContent = "",
    onPadlockClick,
    product,
    productLength,
    isLocked,
    nameProduct = "",
    optionsProduct = [],
    labelProduct = "",
    isTablet,
    productClickCustomFn = () => {},
    showInputs = false,
    readonly = false,
    isMinimal = false,
}) => {
    const { category, imgUrl, url, affiliateUrl, brandName, typeClothes, color } = product;
    const isDesktopFull = !isTablet && !isMinimal;

    //console.log("Product imgUrl", imgUrl);

    const { isLoggedIn } = useUser();

    const handlePadlockClick = () => {
        if (typeof onPadlockClick === "function") {
            onPadlockClick();
        }
    };

    const handleLinkClick = (event: React.MouseEvent<HTMLDivElement>) => {
        console.log('handleLinkClick', event);
        if (readonly) {
            return;
        }
        if (event.target instanceof HTMLDivElement) {
            console.log('Clicked on a div element: ', product);
            if (typeof productClickCustomFn === "function") {
                productClickCustomFn(product);
            }
            else {
                postProductStatistic(product);
                const url = affiliateUrl || product.url;
                if (url) {
                    window.open(url, '_blank');
                }
            }
        }
        //href={affiliateUrl || url} target={'_blank'} 
    }

    return (
        // style={{ backgroundImage: `url(${imgUrl})`, flex: `0 0 ${100 / productLength}%` }} <= flex w zaleznosci od ilosci produktow
        <>
            {/*   */}
            <div
                onClick={(event) => handleLinkClick(event)}
                className={`${container} ${isDesktopFull ? desktopCard : ""} ${className}`}
                style={
                    isDesktopFull
                        ? undefined
                        : {
                              backgroundImage: `url("${imgUrl}")`,
                              flex: isMinimal ? `0 0 ${Math.round(100 / productLength)}%` : `0 0 33%`,
                          }
                }
            >

                {/* <img src={imgUrl} /> */}
                {/* {!isTablet && showInputs && isLoggedIn && <SwitchInput
                    key={product.productId}
                    className={classNameProduct}
                    productLength={productLength}
                    name={nameProduct}
                    options={optionsProduct}
                    label={labelProduct}
                />} */}
                {
                    isTablet && showInputs && isLoggedIn && <div></div>
                }
                {
                    !showInputs && <div></div>
                }
                {
                    !isLoggedIn && <div></div>
                }
                {onPadlockClick && isLoggedIn && (
                    <Padlock
                        onClick={handlePadlockClick}
                        className={padlock}
                        isLocked={Boolean(isLocked)}
                    />
                )}
                {isDesktopFull && (
                    <>
                        <div className={desktopImageWrapper}>
                            <img src={imgUrl} className={desktopImage} alt={category || "Produkt"} />
                        </div>
                        <div className={desktopMeta}>
                            <p className={desktopBrand}>{product.brandName}</p>
                        </div>
                        {!readonly && (
                            <a
                                href={affiliateUrl || url}
                                className={desktopZoom}
                                target={"_blank"}
                                rel="noopener noreferrer"
                                onClick={() => {
                                    postProductStatistic(product);
                                }}
                                aria-label="Przejdź do produktu"
                            >
                                <ViewIcon className={desktopZoomIcon} aria-hidden />
                            </a>
                        )}
                    </>
                )}
                {!readonly && (
                    <div className={`${cardFooter} ${isDesktopFull ? desktopActions : ""}`}>
                        {!isDesktopFull && !isTablet && !isMinimal && brandName ? (
                            <div className={brandBox}>{brandName}</div>
                        ) : null}
                        {isMinimal && <div className={brandBox}>{typeClothes} {color}</div>}
                        <div className={`${classNameButtonContent} ${buttonContent}`}>
                            <a
                                href={affiliateUrl || url}
                                className={button}
                                target={"_blank"}
                                rel="noopener noreferrer"
                                onClick={() => {
                                    postProductStatistic(product);
                                }}
                            >
                                <h2>Sprawdź dostępność</h2>
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ProductCard;
